"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const bundle_1 = require("@yandex-lego/components/Popup/desktop/bundle");
const bundle_2 = require("@yandex-lego/components/next/Calendar/desktop/bundle");
const branding_1 = require("src/context/branding");
const icon_1 = require("src/components/lego/icon");
const input_1 = __importDefault(require("src/components/input"));
const question_1 = __importDefault(require("src/components/question"));
const question_date_styles_1 = __importDefault(require("./question-date.styles"));
const b = b_1.default.with('question-date');
const CALENDAR_SIZE = {
    small: 's',
    medium: 'm',
    large: 'l'
};
const DEMO_CALENDAR_RESIZE = {
    small: '200px',
    medium: '290px',
    large: '390px'
};
// eslint-disable-next-line complexity, max-statements
function DateQuestion(props) {
    var _a, _b;
    const { id, value = '', handleChange = () => { }, handleBlur = () => { }, children, placeholder = '', demoMode = false } = props, rest = __rest(props, ["id", "value", "handleChange", "handleBlur", "children", "placeholder", "demoMode"]);
    const { date: { size = 'small' } = {} } = (0, branding_1.useBrandingContext)() || {};
    const calendarSize = CALENDAR_SIZE[size];
    const inputRef = (0, react_1.useRef)(null);
    const maxDate = ((_a = props === null || props === void 0 ? void 0 : props.range) === null || _a === void 0 ? void 0 : _a.maxDate) ? new Date(Date.parse(props.range.maxDate)) : undefined;
    const minDate = ((_b = props === null || props === void 0 ? void 0 : props.range) === null || _b === void 0 ? void 0 : _b.minDate) ? new Date(Date.parse(props.range.minDate)) : undefined;
    const [isCalendarOpen, setCalendarOpen] = (0, react_1.useState)(false);
    const toggleCalendar = () => {
        setCalendarOpen(prev => !prev);
    };
    // Фикс появления дефолт календаря по клику для Safari
    const handleInputClick = (event) => {
        event.preventDefault();
    };
    const handleCalendarChange = (event) => {
        const adjustedDate = event.value;
        const year = String(adjustedDate.getFullYear()).padStart(4, '0');
        const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
        const day = String(adjustedDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        handleChange({ target: { value: formattedDate } });
        handleBlur({ target: { value: formattedDate } });
        setCalendarOpen(false);
    };
    const demoModeResizeStyle = (0, react_2.css)(`.pages .page {
    margin-bottom: ${DEMO_CALENDAR_RESIZE[size]}};
}`);
    const appliedStyles = [question_date_styles_1.default];
    if (demoMode && isCalendarOpen) {
        appliedStyles.push(demoModeResizeStyle);
    }
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { id: id }, { children: [(0, jsx_runtime_1.jsx)(react_2.Global, { styles: appliedStyles }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('input-wrap date'), ref: inputRef }, { children: [(0, jsx_runtime_1.jsx)(input_1.default, { type: 'date', "data-index": id, size: 'dependent', value: value, onChange: handleChange, onBlur: handleBlur, onClick: handleInputClick, placeholder: placeholder }), (0, jsx_runtime_1.jsx)("button", Object.assign({ type: 'button', className: b('calendar-icon'), onClick: toggleCalendar }, { children: (0, jsx_runtime_1.jsx)(icon_1.Icon, { size: 'm', type: 'q-date' }) }))] })), (0, jsx_runtime_1.jsx)(bundle_1.Popup, Object.assign({ target: 'anchor', anchor: inputRef, direction: ['bottom-start', 'top-start'], view: 'default', visible: isCalendarOpen, onClose: () => setCalendarOpen(false) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('calendar-wrap') }, { children: (0, jsx_runtime_1.jsx)(bundle_2.Calendar, { value: new Date(value || Date.now()), onChange: handleCalendarChange, view: 'default', size: calendarSize, viewsCount: 1, max: maxDate, min: minDate }, value) })) })), children] })));
}
exports.default = DateQuestion;
